import { axiosInstance } from '../../../../network/apis';
import { endpoints } from '../../../../_metronic/constants/paths';

export const companyUserCompanies = endpoints.userCompanies;

export function getAllUserCompanies({ params }: { params?: any }) {
  return axiosInstance.get(companyUserCompanies(), { params });
}
